export var config = {
    noTicketsTitle: "Er zijn helaas geen evenementen op dit moment.",
    noTicketsDescription: "Je favoriete programma vanuit je luie zetel vanop de eerste rij beleven? Kijk live of uitgesteld in een handige gratis app.",
    vtmgoButtonPrefix: "Kijk op",
    vtmgoUrl: "https://www.vtmgo.be",
    actionText: "Reserveer nu alvast je plaats",
    trackingList: "Ticket Overview",
};
